import { render, staticRenderFns } from "./GiftCardEdit.vue?vue&type=template&id=61c40e7c&"
import script from "./GiftCardEdit.vue?vue&type=script&lang=js&"
export * from "./GiftCardEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports